import { Button, SuccessIcon, ProcessingIcon, FailIcon } from "@components";
import RefundSummaryRows from "./RefundSummaryRows";

const Title = ({ children }) => (
  <h1 className="text-2xl font-semibold text-center p-5 border-b border-zinc-100 mb-6">
    {children}
  </h1>
);

const RefundStatusScreen = ({ step, savedForm, onSuccess, onTryAgain }) => {
  const summary = savedForm && (
    <RefundSummaryRows
      amount={savedForm.amount}
      accountHolderName={savedForm.accountHolderName}
      reference={savedForm.reference}
      accountNumber={savedForm.accountNumber}
      sortCode={savedForm.sortCode}
    />
  );

  switch (step) {
    case "PaymentProcessing":
      return (
        <>
          <ProcessingIcon className="mx-auto mt-6 mb-4" />
          <Title>Your refund payment is processing</Title>
          {summary}
        </>
      );
    case "PaymentSucceeded":
      return (
        <>
          <SuccessIcon className="mx-auto mt-6 mb-4" />
          <Title>Your refund has been paid</Title>
          {summary}
          <div className="w-full flex gap-2">
            <Button className="ml-auto mt-8" onClick={onSuccess}>
              Return to dashboard
            </Button>
          </div>
        </>
      );
    case "PaymentFailed":
      return (
        <>
          <FailIcon className="mx-auto mt-6 mb-4" />
          <Title>Your refund payment failed</Title>
          <p className="text-sm mb-5">
            The most likely cause of the failure is incorrect account details.
            Please review the information below. If the issue persists attempt to
            issue the refund through your bank directly.
          </p>
          {summary}
          <div className="w-full flex gap-2">
            <Button className="ml-auto mt-8" onClick={onTryAgain}>
              Try again
            </Button>
          </div>
        </>
      );
    case "completedAlreadyIssued":
      return (
        <>
          <SuccessIcon className="mx-auto mt-6 mb-4" />
          <Title>Marked as refunded</Title>
          {summary}
          <div className="w-full flex gap-2">
            <Button className="ml-auto mt-8" onClick={onSuccess}>
              Return to dashboard
            </Button>
          </div>
        </>
      );
    case "generalError":
      return (
        <>
          <FailIcon className="mx-auto mt-6 mb-4" />
          <Title>An error occurred</Title>
          <p className="text-sm mb-5 text-center">
            An unexpected error occurred. Please try again.
          </p>
          {summary}
          <div className="w-full flex gap-2">
            <Button className="ml-auto mt-8" onClick={onTryAgain}>
              Try again
            </Button>
          </div>
        </>
      );
    default:
      return null;
  }
};

export default RefundStatusScreen;
